import React, { memo, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { HeaderContainer, HeaderInner, HeaderSetUp, IconButton, LeftSection, RightSection } from './ScrollVote.styles';
import UserContext from 'Contexts/User';
import UserWithI from 'Components/icons/UserWithI';
import UserWithIFill from 'Components/icons/UserWithIFill';
import AimWithI from 'Components/icons/AimWithI';
import HeaderScroll from 'Components/HeaderForScroll/HeaderScroll';
import AimWithIFill from 'Components/icons/AimWithIFill';

function ScrollHeader() {
  const [selectedSide, setSelectedSide] = useState<'left' | 'right'>('left');
  const navigate = useNavigate();
  const { userInfo } = useContext(UserContext);
  const [cpmValueShow, setCpmValueShow] = React.useState(0);
  const screenSize = window.innerWidth <= 480 ? 37 : 37;
  const location = useLocation();


  useEffect(() => {
    const voteScore = userInfo?.voteStatistics?.score || 0;
    const totalRewards = userInfo?.rewardStatistics?.total || 0;
    const score = voteScore - totalRewards * 100;
    setCpmValueShow(score);
  }, [
    userInfo?.voteStatistics?.score,
    userInfo?.rewardStatistics?.total,
    userInfo?.rewardStatistics?.claimed,
  ]);

  return (
    <HeaderContainer
      style={{ background: `${(location.pathname === '/' || location.pathname === '/prediction') ? 'transparent' : '#0B011D'}` }}
    >
      <HeaderInner>
        <LeftSection>
          <IconButton
            $borderColor="#fff"
            onClick={() => {
              setSelectedSide('left')
              navigate('/');
            }}
          >
            <UserWithIFill />
            {/* {selectedSide === 'left' ?<UserWithIFill />:<UserWithI />} */}
          </IconButton>
        </LeftSection>
        <HeaderSetUp style={{ display: `${userInfo?.uid ? 'block' : 'none'}` }}>
          <HeaderScroll />
        </HeaderSetUp>

        <RightSection className="desktop-nav">
          <IconButton
            $borderColor="#6A29DD"
            onClick={() => {
              setSelectedSide('right')
              navigate('/prediction');
            }}
          >
            {/* <AimWithI color={selectedSide === 'right' ? '#6A29DD' : '#fff'}/> */}
            <AimWithIFill color={selectedSide === 'right' ? '#6A29DD' : '#fff'} />
          </IconButton>
        </RightSection>
      </HeaderInner>
    </HeaderContainer>
  );
}

export default memo(ScrollHeader);
